import { proxyFetchPost } from '@/api/http';

const ROUTER_API_URL = 'https://router.sbycjk.net/v1';

type RouterElectronApi = {
  getDesktopInstanceId?: () => Promise<string>;
  saveRouterCredential?: (email: string, token: string) => Promise<void>;
  loadRouterCredential?: (email: string) => Promise<string | null>;
  clearRouterCredential?: (email: string) => Promise<void>;
};

function electronApi(): RouterElectronApi | null {
  return window.electronAPI || null;
}

export async function bootstrapEnterpriseRouterCredential(
  email: string
): Promise<boolean> {
  const api = electronApi();
  if (
    !api?.getDesktopInstanceId ||
    !api.saveRouterCredential ||
    !api.loadRouterCredential
  ) {
    return false;
  }
  const deviceId = await api.getDesktopInstanceId();
  const payload = { device_installation_id: deviceId };
  const result = await proxyFetchPost(
    '/api/v1/enterprise/me/router-token/bootstrap',
    payload
  );
  let token = typeof result?.router_token === 'string' ? result.router_token : null;
  if (!token) token = await api.loadRouterCredential(email);
  if (!token) {
    const rotated = await proxyFetchPost(
      '/api/v1/enterprise/me/router-token/rotate',
      payload,
      { 'Idempotency-Key': crypto.randomUUID() }
    );
    token = typeof rotated?.router_token === 'string' ? rotated.router_token : null;
  }
  if (!token) return false;
  await api.saveRouterCredential(email, token);
  return true;
}

export async function resolveEnterpriseRouterModel(email: string | null) {
  if (!email) return null;
  const token = await electronApi()
    ?.loadRouterCredential?.(email)
    .catch(() => null);
  if (!token) return null;
  return {
    api_key: token,
    model_type: 'auto',
    model_platform: 'openai-compatible-model',
    api_url: ROUTER_API_URL,
    model_config_dict: {},
    extra_params: {},
    auth_source: undefined,
  };
}

export async function clearEnterpriseRouterCredential(email: string | null) {
  if (!email) return;
  await electronApi()?.clearRouterCredential?.(email).catch(() => undefined);
}
